<template>
  <div class="user-manage">
    <!-- 查找参数区 -->
    <div class="filter-container">
      <el-input placeholder="请输入用户名" v-model="listQuery.params.user_name" style="width: 200px" class="filter-item"
        maxlength="20" @input="e => listQuery.params.user_name = e.replace(/[^0-9a-zA-Z_]+$/g,'')"></el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
        @click="handleFilter">
        搜索
      </el-button>
    </div>

    <!-- 数据列表区 -->
    <el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%;align: center;">

      <el-table-column prop="userId" label="用户ID" align="center" v-if="false">
      </el-table-column>
      <el-table-column prop="userName" label="用户名" align="center">
      </el-table-column>
      <el-table-column prop="entityName" label="所属单位" align="center">
      </el-table-column>
      <el-table-column prop="wechatId" label="微信用户ID" align="center">
      </el-table-column>
      <el-table-column prop="phone" label="联系方式" align="center">
      </el-table-column>
	  <el-table-column prop="wechatStatusStr" label="告警推送" align="center">
	  </el-table-column>
      <el-table-column prop="operator" label="操作" width="200" align="center">
        <template v-slot:="{row,$index}">
          <el-button type="primary" size="mini" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <pagination :total="totalCounts" @pagination="handlePageChange">
    </pagination>

    <!-- 编辑用户dialog -->
    <el-dialog title="编辑用户" :visible.sync="dialogFormVisible" :before-close="handleClose">
      <el-form :model="editUser" ref="editUser" label-width="120px">

        <el-form-item label="所属单位" prop="entityId">
          <el-select v-model="editUser.entityId" placeholder="请选择所属单位" style="width:100%" :disabled="true">
            <el-option v-for="item in entityIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="editUser.phone" placeholder="请输入联系方式" :maxlength="maxlengthPhone"
            @input="e => editUser.phone = e.replace(/[^\d\-]/g,'')"
            @onkeypress="e=> editUser.phone=e.replace(/[\s+]/g,'')"></el-input>
        </el-form-item>
		
		<el-form-item label="告警推送" prop="wechatStatus">
			<el-select v-model="editUser.wechatStatus" placeholder="是否推送" style="width:100%" >
				<el-option v-for="(item,index) in statusOptions" :key="index" :label="item" :value="index">
				</el-option>
			</el-select>
		</el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelEditUser()">取 消</el-button>
        <el-button type="primary" @click="editUserWechat()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Pagination from '@/components/common/Pagination'
  import { wechatUserList, deleteWechatUser, updateWechatUser} from '@/api/user.js'
  import { formatDate} from '@/utils/date'

  export default {
    name: 'UserManage',
    components: {
      Pagination,
    },
    data() {
	  
      var validatePhone = (rule, value, callback) => {
        // let r = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
        // if (this.error_input === false) {
        //   callback(new Error('手机号格式不正确!'));
        // }
        // callback(new Error(""));
		
		let phone = value;
		let validatedPhone = false;
		if (phone.length == 11 && phone.indexOf("-") == -1) {
		  this.maxlengthPhone = 11;
		}
		if (phone.indexOf("-") != -1) { //座机校验
		  this.maxlengthPhone = 13;
		  // let reg = /^((d{3,4})|d{3,4}-|s)?d{7,14}$/;
		  let reg = /^(0\d{3,4}-\d{7,8})$/
		  // 0\d{2,3}-\d{7,8}
		  if (!(reg.test(phone))) {
		    validatedPhone = false
		  } else {
		    validatedPhone = true;
		  }
		} else { //手机校验
		 let reg = /^1[3456789]\d{9}$/
		 if(!(reg.test(phone))) {
			validatedPhone = false;
		  } else {
		    validatedPhone = true;
		  }
		  console.log(validatedPhone);
		}
		if(!validatedPhone) {
		  console.log("手机号格式不正确")
		  callback(new Error('手机号格式不正确!'));
		} else {
		  callback();
		}
		
      };

      var validateEditedPhone = (rule,value,callback) =>{     
        let phone = value;
        let validatedPhone = false;
        if (phone.length == 11 && phone.indexOf("-") == -1) {
          this.maxlengthPhone = 11;
        }
        if (phone.indexOf("-") != -1) { //座机校验
          this.maxlengthPhone = 13;
          // let reg = /^((d{3,4})|d{3,4}-|s)?d{7,14}$/;
          let reg = /^(0\d{3,4}-\d{7,8})$/
          // 0\d{2,3}-\d{7,8}
          if (!(reg.test(phone))) {
            validatedPhone = false
          } else {
            validatedPhone = true;
          }
        } else { //手机校验
		 let reg = /^1[3456789]\d{9}$/
         if(!(reg.test(phone))) {
			validatedPhone = false;
          } else {
            validatedPhone = true;
          }
          console.log(validatedPhone);
        }
        if(!validatedPhone) {
          console.log("手机号格式不正确")
          callback(new Error('手机号格式不正确!'));
        } else {
          callback();
        }
      };



      return {
        maxlengthPhone: 11,
        error_input: false,
        listLoading: true,
        listData: [],
        totalCounts: 0,
        //搜索条件
        listQuery: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          params: {
            user_name: undefined
          },
          fuzzySearch: true
        },
        
        formLabelWidth: '120px',
        cur_row: null,

        dialogFormVisible: false,
        editUser: {
		  id:null,
          entityId: null,  
          phone: '',
		  wechatStatus:null
        },
        entityIdOptions: [],
		statusOptions:{
			0:"是",
			1:"否"
		}
      }        
    },
    methods: {
      /**
       * handleFilter 用于请求用户数据
       */
      handleFilter() {
        this.listLoading = true
        wechatUserList(this.listQuery).then(res => {
          let data = res.pageData
          this.totalCounts = data.totalCounts
          // 对后端数据进行解析
		  this.listData = data.datas.map(item =>{
			  item.wechatStatusStr = item.wechatStatus == 0 ? '是' : '否'
			  return item
		  })
          this.listLoading = false
        })
      },
      handlePageChange(data) {
        this.listQuery.pageIndex = data.page
        this.listQuery.pageSize = data.limit
        this.handleFilter()
      },
      /**
       * @param {Object} done
       * 点击新建框外提示
       */
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.cancelEditUser();
          })
          .catch(_ => {});

      },
      /**
       * 取消编辑User
       */
      cancelEditUser() {
        this.dialogFormVisible = false
        this.$refs.editUser.resetFields;
        console.log(this.editUser)
      },
      /**
       * handleEdit 打开编辑模态框
       * @param {Object} row
       */
      handleEdit(row) {
        //加载下拉数据//同handleCreate中 该方法一致
        //因为对于当前登录的用户来说entityIdOptions不会改变，所以与新建功能使用同一个
        if (this.entityIdOptions.length === 0) {
          let entitys = JSON.parse(localStorage.entity)
          for (let k in entitys) {
            this.entityIdOptions.push({
              value: k,//注意此处key为字符串
              label: entitys[k]
            })
          }
        }

        //用户id
        this.editUser.id = row.id;
        //设置用户所属单位
        this.editUser.entityId = row.entityId + "";
		this.editUser.phone = row.phone;
		this.editUser.wechatStatus = row.wechatStatus+ ""
		this.dialogFormVisible = true;
      },
      editUserWechat() {
        this.$refs.editUser.validate(valid=>{
          if(!valid) {
            this.$message({
              type: 'info',
              message: '检查输入'
            });
          } else {
			if(this.editUser.entityId != null){
				this.editUser.entityId = parseInt(this.editUser.entityId )
			}
			if(this.editUser.wechatStatus != null){
				this.editUser.wechatStatus = parseInt(this.editUser.wechatStatus )
			}
            updateWechatUser(this.editUser).then(res => {
              if (res.result === "1") {
                this.$message({
                  message: res.message,
                  type: 'success'
                })

                //刷新列表数据
                this.handleFilter()
                //隐藏添加用户模态框
                this.dialogFormVisible = false;
                //重置用户表单数据
                this.$refs.editUser.resetFields();
              } else {
                this.$message.error(res.message)
              }  
              // this.handleFilter()
            })
          }
        })
      },
      /**
       * handleDelete 删除用户
       * @param {Object} row
       */
      handleDelete(row) {
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteWechatUser(row.id).then(res => {
            if (res.result === "1") {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.handleFilter()
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    mounted() {
      this.handleFilter()
    },
  }
</script>

<style>
</style>
